module.exports = __webpack_public_path__ + "img/Germantown_Grille@2x.a8adc19e.webp";